import { PROJECT_STATUS_OPTIONS_DEU } from 'components/BusinessToolForm/constants/deu/options_deu';
import { PROJECT_STATUS_OPTIONS_ES } from 'components/BusinessToolForm/constants/es/options_es';
import { PROJECT_STATUS_OPTIONS } from 'components/BusinessToolForm/constants/options';
import { PROJECT_STATUS_OPTIONS_UA } from 'components/BusinessToolForm/constants/ua/options_ua';

import {
  STAGES_SHORT_LABELS,
  STAGES_SHORT_LABELS_DEU,
  STAGES_SHORT_LABELS_ES,
  STAGES_SHORT_LABELS_UA
} from '../constants/developmentStagesShortLabels';

export const useGetDevelopmentStageData = (language: string) => {
  switch (language) {
    case 'de':
      return PROJECT_STATUS_OPTIONS_DEU.map((option, i) => ({ ...option, label: STAGES_SHORT_LABELS_DEU[i] }));
    case 'uk':
      return PROJECT_STATUS_OPTIONS_UA.map((option, i) => ({ ...option, label: STAGES_SHORT_LABELS_UA[i] }));

    case 'es':
      return PROJECT_STATUS_OPTIONS_ES.map((option, i) => ({ ...option, label: STAGES_SHORT_LABELS_ES[i] }));
    default:
      return PROJECT_STATUS_OPTIONS.map((option, i) => ({ ...option, label: STAGES_SHORT_LABELS[i] }));
  }
};
